export default __webpack_public_path__ + "static/building-dd2196af3b16c9df1291317986e2c919.svg";